import { Wordmark } from "@/components/Wordmark";

export function FullPageLoader({ label = "Loading" }) {
  return (
    <div data-testid="full-page-loader" className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background">
      <Wordmark />
      <div className="flex items-center gap-3">
        <span className="mw-spinner" aria-hidden="true" />
        <span className="mw-eyebrow">{label}</span>
      </div>
    </div>
  );
}
